import React, { useEffect, useRef, useState } from "react";
import "../Sales/Sales.scss";

import { IoSearch } from "react-icons/io5";
import { TbAdjustmentsFilled } from "react-icons/tb";
import { IoIosArrowBack, IoMdClose } from "react-icons/io";
import { LuCalendar } from "react-icons/lu";
import { PiGitBranchBold } from "react-icons/pi";
import { MdOutlineFileDownload } from "react-icons/md";
import { IoCloseCircleOutline, IoAddCircleOutline } from "react-icons/io5";

import { useDispatch, useSelector } from "react-redux";
import { format, parseISO, isToday, isYesterday } from "date-fns";
import Loader from "../../components/Loader/Loader";
import CustomButton from "../../components/CustomButton/CustomButton";
import InputSelect from "../../components/InputSelect/InputSelect";
import {
  fetchOrdersByUser,
  fetchOrdersSummaryByOrganizationAndBranch,
  fetchOrdersToDownloadByOrganizationAndBranch,
} from "../../api/orders";

import ROUTES from "../../constants/routes";
import SwiperButton from "../../components/SwiperButton/SwiperButton";
import { toast } from "react-toastify";
import { deleteSale } from "../../api/sales";
import CalenderOptions from "../../constants/calenderFilterOptions";
import {
  addItemToCart,
  clearCart,
  editSaleCart,
  updatePaymentCustomerDetails,
} from "../../redux/features/cart-slice";
import { useNavigate } from "react-router-dom";
import useOrganizationIsAllowed from "../../helpers/organizationPrevillages";
import { updateOpenSubscriptionAd } from "../../redux/features/subscription-slice";
import { prepareAndDownloadCSV } from "../../helpers/exportSales";
import {
  fetchSalesData,
  updateNetworkStatus,
} from "../../redux/features/home-slice";
import SalesDetails from "../Sales/SalesDetails/SalesDetails";
import { useViewPortDetector } from "../../helpers/viewPortDetector";
import useUserIsAllowed from "../../helpers/userAuthorized";
import {
  loadNextOrders,
  loadOrdersIfNeeded,
  updateExistingOrder,
} from "../../redux/features/orders-slice";
import { storage } from "../../helpers/storage";
import { FiLoader } from "react-icons/fi";
import { Capacitor } from "@capacitor/core";

const statusOptions = [
  { label: "None", value: "none" },
  { label: "Canceled", value: "canceled" },
];

const Orders = ({ userDetails }) => {
  const filterRef = useRef(null);
  const { currentViewPort } = useViewPortDetector();

  const navigate = useNavigate();

  const {
    currency,
    id: organization_id,
    tax_rate,
  } = useSelector((state) => state.organizationReducer.value);

  const { id: branch_id, branches } = useSelector(
    (state) => state.branchReducer.value
  );

  const {
    orders: orgOrders,
    loading: orgOrdersLoading,
    loadingNextPage: orgOrdersLoadingNextPage,
    lastPage: orgOrdersLastPage,
    ordersSummary,
    lastParams,
    loadingBackground,
    loadBackgroundFailed,
  } = useSelector((state) => state.orderReducer.value);

  const dispatch = useDispatch();

  const orgIsAllowedToTakeOrders = useOrganizationIsAllowed("order");
  const orgIsAllowedToUseSalesFilter = useOrganizationIsAllowed("sales_filter");

  useEffect(() => {
    if (orgIsAllowedToTakeOrders.exists) {
      dispatch(updateOpenSubscriptionAd({ openAd: false }));
    } else {
      dispatch(updateOpenSubscriptionAd({ openAd: true }));
    }
  }, [orgIsAllowedToTakeOrders]);

  const [orders, setOrders] = useState();
  const [ordersArray, setOrdersArray] = useState();
  const [loading, setLoading] = useState(false);
  const [openFilter, setOpenFilter] = useState(false);
  const [openSuccess, setOpenSuccess] = useState(false);
  const [openOptions, setOpenOptions] = useState(false);
  const [appliedFilter, setAppliedFilter] = useState([]);
  const [keyword, setKeyword] = useState("");

  const [confirmSuccess, setConfirmSuccess] = useState(false);

  const [selectedBranchFilter, setSelectedBranchFilter] = useState({
    label: "",
    value: "",
  });
  const [selectedStatusFilter, setSelectedStatusFilter] = useState({
    label: "",
    value: "",
  });

  const [selectedCalenderFilter, setSelectedCalenderFilter] = useState(null);
  const [dates, setDates] = useState({
    start_date: null,
    end_date: null,
  });

  const [selectedId, setSelectedId] = useState(null);
  const [selectedOrder, setSelectedOrder] = useState(null);

  const [branchesOptions, setBranchesOptions] = useState([]);
  const [totalData, setTotalData] = useState({
    amount: 0.0,
    sales: 0,
  });

  const [loadingNextPage, setLoadingNextPage] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [currentPageNumber, setCurrentPageNumber] = useState(1);
  const [lastPage, setLastPage] = useState(1);
  const lastItemRef = useRef(null);
  const limit = process.env.REACT_APP_PAGE_LIMIT;

  const [selectedDesktopTag, setSelectedDesktopTag] = useState("Filter");
  const [selectedDesktopOrder, setSelectedDesktopOrder] = useState(null);

  useEffect(() => {
    if (!userDetails) {
      setTotalData({
        amount: ordersSummary?.total_revenue,
        sales: ordersSummary?.total_orders,
      });
    }
  }, [ordersSummary, userDetails]);

  useEffect(() => {
    if (!userDetails) {
      setOrdersArray(orgOrders);
      setLastPage(orgOrdersLastPage);
    }
  }, [userDetails, orgOrders, orgOrdersLastPage, lastParams]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (
          entry.isIntersecting &&
          pageNumber < lastPage &&
          !loadingNextPage &&
          !loading &&
          !orgOrdersLoading &&
          !orgOrdersLoadingNextPage
        ) {
          setPageNumber((prevPage) => prevPage + 1);
        }
      },
      {
        root: null,
        rootMargin: "0px",
        threshold: 1.0,
      }
    );

    const currentRef = lastItemRef.current;

    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, [
    pageNumber,
    lastPage,
    loadingNextPage,
    loading,
    orgOrdersLoading,
    orgOrdersLoadingNextPage,
    lastItemRef.current,
    orders,
  ]);

  const [isScrolling, setIsScrolling] = useState(false);
  const [lastScrollY, setLastScrollY] = useState(0);

  const handleScroll = (e) => {
    const currentScrollTop = e.target.scrollTop;

    setIsScrolling(currentScrollTop > lastScrollY);

    setLastScrollY(currentScrollTop);
  };

  useEffect(() => {
    let options = [];
    branches.forEach((el) => {
      options.push({
        label: el?.name,
        value: el?.id,
      });
    });
    let selectedBranch = options.find((el) => el.value === branch_id);
    setSelectedBranchFilter(selectedBranch);
    setBranchesOptions(options);
  }, [branches, branch_id]);

  const truncateText = (order, maxLength) => {
    const text = order.products
      ? order.products.map((product) => product.name).join(", ")
      : "";
    return text.length > maxLength
      ? text.substring(0, maxLength) + "..."
      : text;
  };

  const groupOrdersByDate = (dataArray) => {
    let total_amount = 0.0;
    let total_sales = 0;
    const groups = dataArray.reduce((acc, order) => {
      const orderDate = new Date(order.created_at);
      let group = "";

      if (isToday(orderDate)) {
        group = "Today";
      } else if (isYesterday(orderDate)) {
        group = "Yesterday";
      } else {
        group = format(orderDate, "dd/MM/yyyy");
      }

      if (!acc[group]) {
        acc[group] = {
          total_amount: 0.0,
          list: [],
        };
      }

      if (!order?.deleted_at) {
        acc[group]["total_amount"] += order?.total_amount || 0;
        total_amount += order?.total_amount || 0;
        total_sales += 1;
      }

      acc[group]["list"].push(order);
      return acc;
    }, {});

    return groups;
  };

  const getOrders = async (
    filter_type,
    start_date,
    end_date,
    page,
    selected_branch_id,
    type
  ) => {
    try {
      const response = await fetchOrdersByUser(
        userDetails?.id,
        organization_id,
        selected_branch_id || branch_id,
        filter_type || "",
        "",
        start_date || "",
        end_date || "",
        keyword,
        page || 1,
        limit,
        type
      );

      setLastPage(response.data?.lastPage || 1);
      setCurrentPageNumber(response?.data?.orders?.current_page || 1);

      return response.data?.orders?.data || [];
    } catch (error) {
      return [];
    }
  };

  const getInitialOrders = async (
    filter_type,
    start_date,
    end_date,
    page,
    selected_branch_id,
    type
  ) => {
    if (userDetails && userDetails?.id) {
      setLoading(true);
      const salesData = await getOrders(
        filter_type,
        start_date,
        end_date,
        page,
        selected_branch_id,
        type
      );
      setOrdersArray(salesData);
      setLoading(false);

      fetchOrdersSummaryByOrganizationAndBranch(
        organization_id,
        selected_branch_id || branch_id,
        filter_type || "last_30_days",
        "",
        start_date,
        end_date,
        userDetails?.id,
        type
      )
        .then((res) => {
          setTotalData({
            amount: res.data?.total_revenue,
            sales: res.data.total_sales,
          });
        })
        .catch(() => {});
    } else {
      dispatch(
        loadOrdersIfNeeded({
          organization_id,
          branch_id: selected_branch_id || branch_id,
          filter_type: filter_type || "",
          start_date: start_date || "",
          end_date: end_date || "",
          keyword,
          type,
        })
      );
    }
    setSelectedDesktopOrder(null);
    setSelectedDesktopTag("Filter");
  };

  const getNextPageOrders = async (
    filter_type,
    start_date,
    end_date,
    selected_branch_id,
    type
  ) => {
    if (userDetails && userDetails?.id) {
      setLoadingNextPage(true);
      const salesData = await getOrders(
        filter_type,
        start_date,
        end_date,
        pageNumber,
        selected_branch_id,
        type
      );
      setOrdersArray((prev) => [...prev, ...salesData]);
      setLoadingNextPage(false);
    } else {
      dispatch(loadNextOrders({ page: pageNumber }));
    }
  };

  useEffect(() => {
    if (ordersArray?.length > 0) {
      const updatedOrdersArray = ordersArray.map((item, index) => ({
        ...item,
        lastItem: index === ordersArray.length - 1,
      }));
      const grouped_orders = groupOrdersByDate(updatedOrdersArray);
      setOrders(grouped_orders);
      const blob = prepareAndDownloadCSV(ordersArray, "orders");
    } else {
      setOrders();
    }
  }, [ordersArray]);

  useEffect(() => {
    let dateFilter = appliedFilter.find((el) => el.label === "Calender");
    const dateFilterTag =
      dateFilter && dateFilter?.filter ? dateFilter?.filter : "";

    let branchFilter = appliedFilter.find((el) => el.label === "Branch");
    const branchFilterTag =
      branchFilter && branchFilter?.filter ? branchFilter?.filter : "";

    let typeFilter = appliedFilter.find((el) => el.label === "Type");
    const typeFilterTag =
      typeFilter && typeFilter?.filter ? typeFilter?.filter : "";

    getInitialOrders(
      dateFilterTag,
      dates.start_date,
      dates.end_date,
      1,
      branchFilterTag,
      typeFilterTag
    );
    setPageNumber(1);
  }, [organization_id, branch_id, keyword, appliedFilter, userDetails]);

  useEffect(() => {
    if (lastPage > currentPageNumber && pageNumber > currentPageNumber) {
      let dateFilter = appliedFilter.find((el) => el.label === "Calender");
      const dateFilterTag =
        dateFilter && dateFilter?.filter ? dateFilter?.filter : "";

      let branchFilter = appliedFilter.find((el) => el.label === "Branch");
      const branchFilterTag =
        branchFilter && branchFilter?.filter ? branchFilter?.filter : "";

      let typeFilter = appliedFilter.find((el) => el.label === "Type");
      const typeFilterTag =
        typeFilter && typeFilter?.filter ? typeFilter?.filter : "";

      getNextPageOrders(
        dateFilterTag,
        dates.start_date,
        dates.end_date,
        branchFilterTag,
        typeFilterTag
      );
    }
  }, [pageNumber]);

  const handleAddFilter = () => {
    const filters = [];

    if (selectedCalenderFilter) {
      if (selectedCalenderFilter === "start_end_date") {
        filters.push({
          label: "Calender",
          value: `Start End Dates`,
          filter: selectedCalenderFilter,
          dates: dates,
        });
      } else {
        const selectedCalenderObj = CalenderOptions.find(
          (el) => el.value === selectedCalenderFilter
        );
        filters.push({
          label: "Calender",
          value: `${selectedCalenderObj?.label}`,
          filter: selectedCalenderFilter,
        });
      }
    }

    if (selectedStatusFilter.value && selectedStatusFilter.value !== "none") {
      filters.push({
        label: "Type",
        value: `${selectedStatusFilter.label}`,
        filter: selectedStatusFilter.value,
      });
    }
    if (selectedBranchFilter.value) {
      if (filters.length > 0 || selectedBranchFilter.value !== branch_id) {
        filters.push({
          label: "Branch",
          value: `${selectedBranchFilter.label}`,
          filter: selectedBranchFilter.value,
        });
      }
    }

    setAppliedFilter(filters);
    setOpenFilter(false);
  };

  const removeFilter = (index) => {
    const tempArray = [...appliedFilter];
    if (tempArray[index]) {
      if (tempArray[index]?.label === "Calender") {
        setDates({
          start_date: null,
          end_date: null,
        });
        setSelectedCalenderFilter(null);
      } else if (tempArray[index]?.label === "Branch") {
        let selectedBranch = branchesOptions.find(
          (el) => el.value === branch_id
        );
        setSelectedBranchFilter(selectedBranch);
      } else if (tempArray[index]?.label === "Type") {
        setSelectedStatusFilter({
          label: "",
          value: "",
        });
      } else if (tempArray[index] === "Search") {
        setKeyword("");
      }
    }
    tempArray.splice(index, 1);
    if (tempArray.length === 1) {
      if (selectedBranchFilter?.value === branch_id) {
        setAppliedFilter([]);
      } else {
        setAppliedFilter(tempArray);
      }
    } else {
      setAppliedFilter(tempArray);
    }
  };

  const [maxHeight, setMaxHeight] = useState(0);

  useEffect(() => {
    if (filterRef && filterRef.current) {
      setMaxHeight(filterRef.current.clientHeight);
    }
  }, [filterRef, appliedFilter]);

  const [downloading, setDownloading] = useState(false);

  const handleDownload = () => {
    if (downloading) {
      return;
    }
    setDownloading(true);
    let dateFilter = appliedFilter.find((el) => el.label === "Calender");
    const dateFilterTag =
      dateFilter && dateFilter?.filter ? dateFilter?.filter : "";

    let branchFilter = appliedFilter.find((el) => el.label === "Branch");
    const branchFilterTag =
      branchFilter && branchFilter?.filter ? branchFilter?.filter : "";

    let typeFilter = appliedFilter.find((el) => el.label === "Type");
    const typeFilterTag =
      typeFilter && typeFilter?.filter ? typeFilter?.filter : "";

    fetchOrdersToDownloadByOrganizationAndBranch(
      organization_id,
      branchFilterTag || branch_id,
      dateFilterTag,
      "",
      dates.start_date,
      dates.end_date,
      userDetails?.id || "",
      typeFilterTag
    )
      .then(async (res) => {
        if (res.data?.sales?.length > 0) {
          const blob = prepareAndDownloadCSV(res.data?.sales, "orders");

          if (Capacitor.isNativePlatform()) {
            const csvBlob = new Blob([blob], { type: "text/csv;charset=utf-8;" });
            const csvUrl = window.URL.createObjectURL(csvBlob);
            window.open(csvUrl, "_blank");
            window.URL.revokeObjectURL(csvUrl);
          } else {
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.download = "orders.csv";
            link.click();
            window.URL.revokeObjectURL(url);
          }
          toast.dismiss();
          toast.success("Orders CSV download started.");
        } else {
          setDownloading(false);
          toast.dismiss();
          toast.info("No data to export.");
        }
      })
      .catch((err) => {})
      .finally(() => {
        setDownloading(false);
      });
  };

  const handleOrderClick = (orderItem) => {
    if (!orderItem?.deleted_at) {
      setOpenOptions(true);
      setSelectedId(orderItem?.id);
      setSelectedOrder(orderItem);
      setSelectedDesktopOrder(null);
      setSelectedDesktopTag("Filter");
    } else {
      if (currentViewPort === "desktop") {
        setSelectedDesktopOrder(orderItem);
        setSelectedDesktopTag("Order Details");
      } else {
        navigate(ROUTES.salesDetails.path, {
          state: {
            item: orderItem,
            userData: userDetails,
            isOrder: true,
            customerData: null,
          },
        });
      }
    }
  };

  const resetFilterToDefault = () => {
    setAppliedFilter([]);
    let selectedBranch = branchesOptions.find((el) => el.value === branch_id);
    setSelectedBranchFilter(selectedBranch);
    setSelectedCalenderFilter(null);
    setSelectedStatusFilter({
      label: "",
      value: "",
    });
    setDates({
      start_date: null,
      end_date: null,
    });
  };

  useEffect(() => {
    if (loadingBackground) {
      dispatch(updateNetworkStatus({ status: "syncing" }));
    }
  }, [loadingBackground]);

  return (
    <>
      {(loading || orgOrdersLoading) && <Loader />}
      <div className="page-with-side-components">
        <div className={`sales`}>
          {!userDetails && (
            <div className="desktop-navbar box-shadow">
              <p>{ROUTES.orders.title}</p>
              <div className="last-tag-svg">
                <TbAdjustmentsFilled
                  onClick={() => {
                    setSelectedDesktopTag("Filter");
                    setSelectedDesktopOrder(null);
                  }}
                />
              </div>
            </div>
          )}
          <div className={`sales-page-content ${openFilter ? "inactive" : ""}`}>
            <div className="sales-search" ref={filterRef}>
              {appliedFilter.length > 0 ? (
                <div className="applied-filters">
                  <div className="heading">
                    <TbAdjustmentsFilled />
                    <p>Filters used</p>
                  </div>
                  <div className="flex-container">
                    {appliedFilter.map((el, i) => {
                      return (
                        <div className="item">
                          <p>
                            {el?.label} : {el?.value}
                          </p>
                          <IoCloseCircleOutline
                            onClick={() => {
                              removeFilter(i);
                            }}
                          />
                        </div>
                      );
                    })}
                    <div
                      className="item add-more"
                      onClick={() => {
                        setOpenFilter(true);
                      }}
                    >
                      <p>Add More</p>
                      <IoAddCircleOutline />
                    </div>
                    <div
                      className="item clear-all"
                      onClick={resetFilterToDefault}
                    >
                      <p>Clear All</p>
                    </div>
                  </div>
                </div>
              ) : (
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    setKeyword(e.target.keyword.value);
                  }}
                  className="inputs"
                >
                  <input
                    type="text"
                    name="keyword"
                    defaultValue={keyword}
                    placeholder="Search by item, price or code."
                  />
                  <button type="submit">
                    <IoSearch />
                  </button>
                </form>
              )}
            </div>

            <div
              className="sales-list container-wrapper"
              style={
                userDetails
                  ? { maxHeight: `calc(var(--vh) - 127px - ${maxHeight}px)` }
                  : { maxHeight: `calc(var(--vh) - 50px - ${maxHeight}px)` }
              }
              onScroll={handleScroll}
            >
              {orders ? (
                Object.keys(orders).map((group, i) => {
                  const isLastGroup = i === Object.keys(orders).length - 1;
                  return (
                    <div className="sales-group" key={i}>
                      <div className="heading">
                        <p className="head-title">{group}</p>
                        <p className="total">
                          Total:{" "}
                          <span>
                            {currency}
                            {Number(orders[group]["total_amount"] || 0).toFixed(
                              2
                            )}
                          </span>
                        </p>
                      </div>
                      <div className="lists">
                        {orders[group]["list"]?.map((orderItem, i) => {
                          if (orderItem?.lastItem) {
                            return (
                              <div
                                ref={lastItemRef}
                                onClick={() => {
                                  handleOrderClick(orderItem);
                                }}
                                className={`sale-item ${
                                  orderItem?.deleted_at ? "deleted" : ""
                                } ${
                                  selectedDesktopOrder?.id === orderItem?.id
                                    ? "highlight-selected-item"
                                    : ""
                                }`}
                                key={i}
                              >
                                <div className="left">
                                  <p className="total">
                                    {currency}
                                    {Number(orderItem?.total_amount).toFixed(2)}
                                  </p>
                                  <p className="user">
                                    {orderItem?.customer
                                      ? `👤 ${orderItem?.customer?.name}`
                                      : ""}
                                  </p>
                                  <p className="product-names">
                                    {truncateText(orderItem, 25)}
                                  </p>
                                </div>

                                <div className="right">
                                  <p className="time">
                                    {format(
                                      new Date(orderItem?.created_at),
                                      "p"
                                    )}
                                  </p>
                                  <p className="sale-id-web">
                                    {orderItem?.deleted_at && "Canceled"} #{" "}
                                    {orderItem?.sale_id}
                                  </p>
                                  <p className="time">
                                    Sold by:{" "}
                                    {`${orderItem?.user?.name}`.split(" ")[0]}
                                  </p>
                                </div>
                              </div>
                            );
                          } else {
                            return (
                              <div
                                onClick={() => {
                                  handleOrderClick(orderItem);
                                }}
                                className={`sale-item ${
                                  orderItem?.deleted_at ? "deleted" : ""
                                }  ${
                                  selectedDesktopOrder?.id === orderItem?.id
                                    ? "highlight-selected-item"
                                    : ""
                                }`}
                                key={i}
                              >
                                <div className="left">
                                  <p className="total">
                                    {currency}
                                    {Number(orderItem?.total_amount).toFixed(2)}
                                  </p>
                                  <p className="user">
                                    {orderItem?.customer
                                      ? `👤 ${orderItem?.customer?.name}`
                                      : ""}
                                  </p>
                                  <p className="product-names">
                                    {truncateText(orderItem, 25)}
                                  </p>
                                </div>

                                <div className="right">
                                  <p className="time">
                                    {format(
                                      new Date(orderItem?.created_at),
                                      "p"
                                    )}
                                  </p>
                                  <p className="sale-id-web">
                                    {orderItem?.deleted_at && "Canceled"} #{" "}
                                    {orderItem?.sale_id}
                                  </p>
                                  <p className="time">
                                    Sold by:{" "}
                                    {`${orderItem?.user?.name}`.split(" ")[0]}
                                  </p>
                                </div>
                              </div>
                            );
                          }
                        })}
                        {(loadingNextPage || orgOrdersLoadingNextPage) &&
                          isLastGroup && (
                            <div className="loading-next-sales-items">
                              <div className="left">
                                <div className="total"></div>
                                <div className="user"></div>
                                <div className="product-names"></div>
                              </div>
                              <div className="right">
                                <div className="time"></div>
                                <div className="sale-id-web"></div>
                              </div>
                            </div>
                          )}
                      </div>
                    </div>
                  );
                })
              ) : (
                <div
                  className="no-sales"
                  style={{
                    maxHeight: `calc(var(--vh) - 50px - ${maxHeight}px)`,
                    minHeight: `calc(var(--vh) - 50px - ${maxHeight}px)`,
                  }}
                >
                  <img src="/images/search.svg" alt="" aria-label="No Items" />
                  <p>You haven't made a order during this period</p>
                  <span>Questions ? Learn more about this feature</span>
                </div>
              )}
            </div>
          </div>

          <div
            className={`filter-page-content container-wrapper ${
              openFilter ? "active" : ""
            }`}
          >
            <DateFilter
              dispatch={dispatch}
              dates={dates}
              setDates={setDates}
              selectedCalenderFilter={selectedCalenderFilter}
              setSelectedCalenderFilter={setSelectedCalenderFilter}
              orgIsAllowedToUseSalesFilter={orgIsAllowedToUseSalesFilter}
            />
            <OtherFilter
              setSelectedBranchFilter={setSelectedBranchFilter}
              setSelectedStatusFilter={setSelectedStatusFilter}
              selectedStatusFilter={selectedStatusFilter}
              selectedBranchFilter={selectedBranchFilter}
              branchesOptions={branchesOptions}
            />
          </div>

          <div
            className={`open-filter-icon ${
              userDetails && selectedDesktopTag === "Filter" ? "active" : ""
            }`}
          >
            <TbAdjustmentsFilled
              onClick={() => {
                setOpenFilter((pre) => !pre);
              }}
            />
          </div>
          {openFilter && (
            <div className="close-filter-icon">
              <IoMdClose
                onClick={() => {
                  setOpenFilter(false);
                }}
              />
              <p>Filter</p>
            </div>
          )}
          {openFilter && (
            <div className="floating-button">
              <CustomButton
                name={`Apply Filter`}
                type={"button"}
                color={"primary"}
                bigButton={true}
                handleSubmit={handleAddFilter}
              />
            </div>
          )}

          {!openFilter && (
            <div
              className={`download-sales-csv ${isScrolling ? "inactive" : ""}`}
            >
              <p>
                {currency}
                {totalData.amount} from {totalData.sales} orders (
                {CalenderOptions.find(
                  (el) => el.value === selectedCalenderFilter
                )?.label || "Last 30 days"}
                )
              </p>
              <div className="svg" onClick={handleDownload}>
                {downloading ? (
                  <FiLoader className="loader" />
                ) : (
                  <MdOutlineFileDownload />
                )}
              </div>
            </div>
          )}

          <SuccessModel
            open={openSuccess}
            setOpen={setOpenSuccess}
            confirmSuccess={confirmSuccess}
          />

          <OrderOptionsModel
            open={openOptions}
            ordersArray={ordersArray}
            setOrdersArray={setOrdersArray}
            setOpen={setOpenOptions}
            setOpenSuccess={setOpenSuccess}
            setConfirmSuccess={setConfirmSuccess}
            selectedId={selectedId}
            selectedOrder={selectedOrder}
            tax_rate={tax_rate}
            branchId={branch_id}
            organizationId={organization_id}
            userDetails={userDetails}
          />

          {(openSuccess || openOptions) && (
            <div
              className="blur-back"
              onClick={() => {
                setOpenSuccess(false);
                setOpenOptions(false);
              }}
            ></div>
          )}
        </div>

        <div
          className={`right-desktop-view ${userDetails ? "absolute" : ""} ${
            selectedDesktopTag !== "Filter" ? "active" : ""
          }`}
        >
          <div className="desktop-navbar box-shadow border-bottom">
            {selectedDesktopTag !== "Filter" && (
              <div
                className="back"
                onClick={() => {
                  setSelectedDesktopTag("Filter");
                  setSelectedDesktopOrder(null);
                }}
              >
                <IoIosArrowBack />
              </div>
            )}
            <p>{selectedDesktopTag}</p>
          </div>

          {selectedDesktopTag === "Filter" && !userDetails && (
            <div
              className={`filter-page-content container-wrapper active side-view`}
            >
              <DateFilter
                dispatch={dispatch}
                dates={dates}
                setDates={setDates}
                selectedCalenderFilter={selectedCalenderFilter}
                setSelectedCalenderFilter={setSelectedCalenderFilter}
                orgIsAllowedToUseSalesFilter={orgIsAllowedToUseSalesFilter}
              />
              <OtherFilter
                setSelectedBranchFilter={setSelectedBranchFilter}
                setSelectedStatusFilter={setSelectedStatusFilter}
                selectedStatusFilter={selectedStatusFilter}
                selectedBranchFilter={selectedBranchFilter}
                branchesOptions={branchesOptions}
              />
              <div className="floating-button">
                <CustomButton
                  name={`Apply Filter`}
                  type={"button"}
                  color={"primary"}
                  bigButton={true}
                  handleSubmit={handleAddFilter}
                />
              </div>
            </div>
          )}

          {selectedDesktopTag === "Order Details" && (
            <SalesDetails
              desktopView={true}
              sale={selectedDesktopOrder}
              setSelectedDesktopTag={setSelectedDesktopTag}
              order={true}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default Orders;

const DateFilter = ({
  dispatch,
  dates,
  setDates,
  selectedCalenderFilter,
  setSelectedCalenderFilter,
  orgIsAllowedToUseSalesFilter,
}) => {
  const handleDateChange = (e) => {
    const { name, value } = e.target;
    setDates({ ...dates, [name]: value });
  };

  useEffect(() => {
    if (dates.start_date && dates.end_date) {
      setSelectedCalenderFilter("start_end_date");
    } else if (dates.start_date || dates.end_date) {
      setSelectedCalenderFilter(null);
    }
  }, [dates]);

  const clearDates = () => {
    setDates({
      start_date: null,
      end_date: null,
    });
  };

  return (
    <div className="date-filter filter-container">
      <p className="heading">
        <LuCalendar /> Date Range
      </p>

      <div className="date-range">
        <div className="date-input">
          <input
            type="date"
            name="start_date"
            onChange={(e) => {
              if (orgIsAllowedToUseSalesFilter?.exists) {
                handleDateChange(e);
              } else {
                dispatch(updateOpenSubscriptionAd({ openAd: true }));
              }
            }}
          />
          <p>{dates.start_date || "Start Date"}</p>
        </div>
        <p>to</p>
        <div className="date-input">
          <input
            type="date"
            name="end_date"
            onChange={(e) => {
              if (orgIsAllowedToUseSalesFilter?.exists) {
                handleDateChange(e);
              } else {
                dispatch(updateOpenSubscriptionAd({ openAd: true }));
              }
            }}
          />
          <p>{dates.end_date || "End Date"}</p>
        </div>
      </div>

      <div className="grid-list-dates">
        {CalenderOptions.map((el, i) => {
          return (
            <div
              className={`item ${
                selectedCalenderFilter === el.value ? "active" : ""
              }`}
              key={i}
              onClick={() => {
                if (selectedCalenderFilter === el.value) {
                  setSelectedCalenderFilter(null);
                } else {
                  setSelectedCalenderFilter(el.value);
                  clearDates();
                }
              }}
            >
              {el.label}
            </div>
          );
        })}
      </div>
    </div>
  );
};

const OtherFilter = ({
  setSelectedBranchFilter,
  setSelectedStatusFilter,
  selectedStatusFilter,
  selectedBranchFilter,
  branchesOptions,
}) => {
  return (
    <div className="other-filter filter-container">
      <p className="heading">
        <PiGitBranchBold /> Other Options
      </p>

      <div className="other-selects">
        <InputSelect
          options={statusOptions}
          value={selectedStatusFilter}
          register={() => {}}
          required={false}
          name="status"
          handleChange={(opt) => {
            setSelectedStatusFilter(opt);
          }}
          reset={() => {}}
          label={"Status"}
          inputErrors={{}}
        />

        <InputSelect
          options={branchesOptions}
          value={selectedBranchFilter}
          register={() => {}}
          required={false}
          name="branch"
          handleChange={(opt) => {
            setSelectedBranchFilter(opt);
          }}
          reset={() => {}}
          label={"Branch"}
          inputErrors={{}}
        />
      </div>
    </div>
  );
};

const SuccessModel = ({ open, setOpen, confirmSuccess }) => {
  const [shouldRender, setShouldRender] = useState(false);

  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (open) {
      setShouldRender(true);
      setTimeout(() => {
        setIsVisible(true);
      }, 10);
    } else if (isVisible) {
      setIsVisible(false);
      setTimeout(() => {
        setShouldRender(false);
      }, 300);
    }
  }, [open, isVisible]);

  if (!shouldRender) return null;
  return (
    <div className={`success-model ${isVisible ? "active" : ""}`}>
      <div className="upper">
        <img
          src={confirmSuccess ? "/images/cloud.svg" : "/images/celebration.gif"}
          alt=""
          aria-label="Success"
        />
        <p>{confirmSuccess ? "Congratulations !" : "Success !"}</p>
      </div>
      <p>
        The Order has been successfully{" "}
        {confirmSuccess ? "converted to a sale." : "canceled."}
      </p>

      <CustomButton
        type={"button"}
        name={"Continue"}
        color={"primary"}
        handleSubmit={() => {
          setOpen(false);
        }}
      />
    </div>
  );
};

const OrderOptionsModel = ({
  open,
  setOpen,
  setOrdersArray,
  setOpenSuccess,
  selectedId,
  setConfirmSuccess,
  selectedOrder,
  tax_rate,
  branchId,
  organizationId,
  userDetails,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { currentViewPort } = useViewPortDetector();

  const userIsAdministrator = useUserIsAllowed("administrator");
  const userIsAllowedToManageInventory = useUserIsAllowed("manage_inventory");

  const userIsAllowedToCancelOrder =
    userIsAdministrator || userIsAllowedToManageInventory;
  const userIsAllowedToChangeOrderToSale = useUserIsAllowed(
    "add_orders_or_sales"
  );

  const handleConfirmOrder = (isEdit) => {
    if (userIsAllowedToChangeOrderToSale) {
      if (selectedOrder) {
        dispatch(clearCart());
        storage.remove("cart");
        const editSaleData = {
          saleId: selectedOrder?.id || null,
          tax: selectedOrder?.tax || 0.0,
          tax_rate: tax_rate || 0,
          delivery_charge: selectedOrder?.delivery_charge || 0.0,
          cash_discount: selectedOrder?.cash_discount || 0.0,
          percent_discount: selectedOrder?.percent_discount || 0.0,
        };

        const customer_number =
          `${selectedOrder?.customer?.phone_number}`.split(" ");

        const customerData = {
          customer_name: selectedOrder?.customer?.name || "",
          customer_number:
            customer_number?.length > 0 ? customer_number[1] : "",
          customer_country_code:
            customer_number?.length >= 0 ? customer_number[0] : "",
          customer_id: selectedOrder?.customer?.id || null,
          customer_address: selectedOrder?.customer?.address_line || null,
          customer_allow_pay_later: selectedOrder?.customer?.pay_later || false,
          customer_credit_amount:
            selectedOrder?.customer?.current_balance || 0.0,
        };

        dispatch(updatePaymentCustomerDetails(customerData));
        dispatch(editSaleCart(editSaleData));

        const cart = [];
        selectedOrder?.products?.map(async (el) => {
          let itemData = {};
          if (el?.nonInventory) {
            itemData = {
              newItem: {
                product: el,
                quantity: el?.quantity || 0,
                nonInventory: true,
              },
            };
          } else {
            itemData = {
              newItem: {
                product: el,
                quantity: el?.pivot?.quantity || 0,
              },
            };
          }
          cart.push(itemData);
          dispatch(addItemToCart(itemData));
        });
        storage.set("cart", JSON.stringify(cart));
        if (isEdit) {
          if (currentViewPort === "desktop") {
            navigate(ROUTES.checkout.path);
          } else {
            navigate(ROUTES.cart.path);
          }
        } else {
          navigate(ROUTES.payment.path);
        }
      } else {
        toast.dismiss();
        toast.error("Order not selected.");
        setOpen(false);
      }
    } else {
      toast.dismiss();
      toast.info(
        "You do not have sufficient permissions to perform this action. Please contact your administrator."
      );
      setOpen(false);
    }
  };

  const handleCancelOrder = () => {
    if (userIsAllowedToCancelOrder) {
      if (selectedId) {
        deleteSale(selectedId)
          .then((res) => {
            setConfirmSuccess(false);
            setOpenSuccess(true);
            setOpen(false);
            dispatch(
              fetchSalesData({
                organization_id: organizationId,
                branch_id: branchId,
              })
            );

            if (userDetails) {
              setOrdersArray(res.data?.sale);
            }
            dispatch(
              updateExistingOrder({
                order: res.data?.sale,
              })
            );
          })
          .catch((err) => {
            if (err?.response?.data?.message) {
              if (err?.response?.data?.message === "User not authorized!") {
                toast.dismiss();
                toast.error(
                  "You do not have sufficient permissions to perform this action. Please contact your administrator."
                );
              } else {
                toast.dismiss();
                toast.error(`${err?.response?.data?.message}`);
              }
            } else {
              toast.dismiss();
              toast.error("Error while canceling order.");
            }
          });
      } else {
        toast.dismiss();
        toast.error("Order not selected.");
        setOpen(false);
      }
    } else {
      toast.dismiss();
      toast.info(
        "You do not have sufficient permissions to perform this action. Please contact your administrator."
      );
      setOpen(false);
    }
  };

  const [shouldRender, setShouldRender] = useState(false);

  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (open) {
      setShouldRender(true);
      setTimeout(() => {
        setIsVisible(true);
      }, 10);
    } else if (isVisible) {
      setIsVisible(false);
      setTimeout(() => {
        setShouldRender(false);
      }, 300);
    }
  }, [open, isVisible]);

  if (!shouldRender) return null;
  return (
    <div className={`orders-options ${isVisible ? "active" : ""}`}>
      <p className="heading">Order options</p>

      <div className="swiper-options">
        <SwiperButton
          name={"Confirm Order"}
          onComplete={handleConfirmOrder}
          color={"primary"}
          type={"right"}
        />
        <SwiperButton
          name={"Cancel Order"}
          onComplete={handleCancelOrder}
          color={"danger"}
          type={"left"}
        />
      </div>

      <div className="buttons" style={{ gap: "22px" }}>
        <CustomButton
          type={"button"}
          name={"Cancel"}
          color={"danger"}
          handleSubmit={() => {
            setOpen(false);
          }}
        />
        <CustomButton
          type={"button"}
          name={"Edit"}
          color={"primary"}
          handleSubmit={() => {
            handleConfirmOrder(true);
          }}
        />
      </div>
    </div>
  );
};
